export const PlaceMenuItemKey = {
  EDIT_PLACE: 'edit-place',
  ADDRESS: 'address',
  CONTACT: 'contact',
  EMPLOYEES: 'employees',
  SOPS: 'sops',
  VEHICLES: 'vehicles',
};
